export const getVideoMimeType = (fileExt: string): string => {
  switch (fileExt) {
    case '.mp4':
      return 'video/mp4'
    case '.webm':
      return 'video/webm'
    case '.ogv':
      return 'video/ogg'
    default:
      return ''
  }
}
